import {UUID} from '@nh/angular-tses';
import {DepartureProperties} from 'app/diary/properties/departure-properties';
import {DepartureComment} from '../comment/departure-comment';
import {DeparturePermissions} from '../permissions/departure-permissions';
import {DepartureWorkflowState} from '../workflow/departure-workflow-state';
import {DepartureLink} from './diary-event';
import {DepartureReasonCodes} from './reason-codes/reason-codes.service';

export interface DiarySnapshot {
  workflowState?: DepartureWorkflowState;
  comment?: DepartureComment;
  link?: DepartureLink;
  permissions?: DeparturePermissions;
  properties?: DepartureProperties;
  reasonCodes?: DepartureReasonCodes;
}

export function departureIdFromSnapshot(snapshot: DiarySnapshot): UUID {
  if (snapshot) {
    if (snapshot.workflowState) {
      return UUID.orNull(snapshot.workflowState.associatedObjectId);
    } else if (snapshot.comment) {
      return UUID.orNull(snapshot.comment.departureId);
    } else if (snapshot.permissions) {
      return UUID.orNull(snapshot.permissions.departureId);
    } else if (snapshot.properties) {
      return UUID.orNull(snapshot.properties.departureId);
    } else if (snapshot.reasonCodes) {
      return UUID.orNull(snapshot.reasonCodes.departureId);
    } else if (snapshot.link) {
      return UUID.orNull(snapshot.link.departureId);
    }
  } else {
    return null;
  }
}
